<template>
  <div>

  </div>
</template>

<script>
export default {
  name: "ErrorDisplay",
}
</script>

<style scoped>

</style>